import { forwardRef } from "react";
import "./DropdownContent.css";

const DropdownContent = forwardRef((props, ref) => {
  const { children, open, top , toggle } = props;
  return (
    <div
      className={`dropdown-content ${open ? "content-open" : null}`}
      style={{ top: top ? `${top}px` : "100%" }}
      ref={ref}
      onClick={toggle}
    >
      {children}
    </div>
  );
});

export default DropdownContent;
